<div class="layout-default">
    <div #Column1 style="background-color: #ff5252; flex-basis: 30%;"></div>
    <pm-thumb [ItemOrientation]="'Horizontal'"
              [Mode]="'Basis'"
              [ElementFlexBasis]="Column1">
    </pm-thumb>
    <div style="flex: 1; display: flex; flex-direction: column;">
        <div style="background-color: #1E88E5; flex: 1;"></div>
        <pm-thumb [ItemOrientation]="'Vertical'"></pm-thumb>
        <div style="background-color: #1EE56A; flex: 1;"></div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-2.html